export const getCustomerIdFromUserInfo = userInfo => {
  if (userInfo.groups) {
    const customerGroup = userInfo.groups.find(group => {
      return group.match(/^customer\..*\..*/);
    });
    return customerGroup?.split('.')[1];
  }
};
